// MyContext.js
import React, {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { apiInstance, routes } from "../../../helpers/API";
import { headerDate } from "./constants";
import {
  calculateCapacityTillMidnight,
  convertToMinutes,
  incrementTime,
  tConverter,
} from "../../../helpers/utils";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../store/actions";
import dayjs from "dayjs";
import scopeService from "../../../store/services/scope.service";
import moment from "moment";
import { getProjectProgressSummary } from "../../../store/actions/projects.actions";

const ResourceMoniteringContext = createContext();

const ResourceMoniteringProvider = ({ children }) => {
  const displatch = useDispatch();
  const [expRes, setExpRes] = useState(false);
  const [expClients, setExpClients] = useState(false);
  const [expMettings, setExpMettings] = useState(false);
  const [expProjects, setExpProjects] = useState(false);
  const [calendarData, setCalendarData] = useState([]);
  const [useDetails, setUserDetails] = useState([]);
  const [calendarHeader, setCalendarHeader] = useState([]);
  const [selectedTab, setSelectedTab] = useState("summary");
  const [tabView, setTabView] = useState("month");
  const [todayTrigger, setTodayTrigger] = useState(false);
  const [project, setProject] = useState({ name: "All Projects" });
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [isTimelineLoading, setIsTimelineLoading] = useState(false);
  const [isInitialTimelineLoading, setIsInitialTimelineLoading] = useState(false);
  const [isCalendarLoading, setIsCalendarLoading] = useState(false);

  const [filterCount, setFilterCount] = useState(0);
  const [detail, setDetail] = useState(null);
  const [addShiftView, setAddShiftView] = useState(false);
  const [hourlyIdentifier, setHourlyIdentifier] = useState(null);
  const [openPopover, setIsOpenPopover] = useState(null);
  const [filterUsers, setFilterUsers] = useState([]);
  const [assignedResources, setAssignedResources] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedValue, setSelectedValue] = useState("Saved Shift");
  const [selectedShift, setSelectedShift] = useState("");
  const [name, setname] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [editShift, setEditShift] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [filterShifts, setFilterShifts] = useState([]);
  const [filterCapacity, setFilterCapacity] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [taskLoader, setTaskLoader] = useState(true);
  const [scopeItems, setScopeItems] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [isBaselineable, setIsBaselineable] = useState(null);
  const [baselinez, setBaselines] = useState([]);
  const [filterBaseline, setFilterBaseLine] = useState(null);
  const [gantTrigger, setGanttTrigger] = useState(false);
  const [taskLinks, setTaskLinks] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [taskId, setTaskId] = useState(null);
  const [scopeId, setScopeId] = useState(null);
  const [peerTasks, setPeerTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [scopes, setScopes] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [baselineScopes, setBaselineScopes] = useState([]);
  const [displayYearRange, setdisplayYearRange] = useState({ start: moment().year(), end: moment().year() });
  const debounceRef = useRef(false);
  const settings = JSON.parse(localStorage.getItem("settings"));

  // Conflicts toasts
  const [conflictsToasts, setConflictsToasts] = useState([]);

  const addConflictsToast = useCallback((toast) => {
    setConflictsToasts((prev) => [...prev, toast]);
  }, []);

  const removeConflictsToast = useCallback((index) => {
    setConflictsToasts((prev) => prev.filter((_, i) => i !== index));
  }, []);

  useEffect(() => {
    if (selectedTab !== "summary") {
      fetchAndSetTimelineData(true);
    }
  }, [
    selectedTab,
    tabView,
    project,
    gantTrigger,
    filterStartDate,
    filterEndDate,
    filterUsers,
  ]);

  const fetchAndSetTimelineData = (initialLoading = false) => {
    try {
      if (initialLoading == true)
        setIsInitialTimelineLoading(true);

      if (!project?.id) return;
      let filter = "";
      if (filterUsers.length > 0) {
        filter += `&Resources=${filterUsers.map((item) => item.id).join(",")}`;
      }

      if (filterBaseline) {
        filter += `&BaselineId=${filterBaseline}`;
      }

      if (filterStatus.length > 0) {
        filter = `&TaskStatus=${filterStatus.map((item) => item).join(",")}`;
      }

      if (filterStartDate && filterEndDate) {
        filter += `&StartDate=${filterStartDate}&endDate=${filterEndDate}`;
      } else if (filterStartDate) {
        filter += `&StartDate=${filterStartDate}`;
      }

      apiInstance
        .get(
          `${routes.timeline.replace(
            ":id",
            project.id
          )}?view=${tabView}${filter}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage
                ?.getItem("accessToken")
                ?.replace(/"/g, "")}`,
            },
          }
        )
        .then((res) => {
          setdisplayYearRange({ start: res?.data?.yearRange?.start, end: res?.data?.yearRange?.end });
          setScopes(res?.data?.scopes ?? []);
          setMilestones(res?.data?.milestones ?? []);
          setBaselineScopes(res?.data?.baselineScopes ?? []);
          modefyTimelineResponse(res?.data?.scopes, res?.data.baselineScopes);
        })
        .catch((error) => {
          displatch(
            generalActions.showToast({
              title: error.message,
              type: "error",
            })
          );
        })
        .finally(() => {
          if (initialLoading == true)
            setIsInitialTimelineLoading(false);
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  useEffect(() => {

    if (selectedTab === "resourceMonitoring") {
      fetchCalendarDetails(true);
    }
  }, [
    selectedTab,
    tabView,
    project,
    gantTrigger,
    filterStartDate,
    filterEndDate,
    filterUsers,
    filterShifts,
    filterCapacity,
  ]);

  const fetchCalendarDetails = async (status = false) => {
    if (status) {
      setIsCalendarLoading(true);
    }
    try {
      /*if (!project?.id) {
        setUserDetails([]);
        setCalendarHeader([]);
        setCalendarData([]);
        return;
      }*/
      let filter = "";
      if (project.name !== "All Projects") {
        filter += `&ProjectId=${project.id}`;
      }
      if (filterShifts.length > 0) {
        filter += `&Shifts=${filterShifts.map((item) => item).join(",")}`;
      }
      if (taskId) {
        filter += `&TaskId=${taskId}`;
      }
      if (scopeId) {
        filter += `&ScopeId=${scopeId}`;
      }
      if (filterUsers.length > 0) {
        filter += `&Resources=${filterUsers.map((item) => item.id).join(",")}`;
      }
      if (filterCapacity.length > 0) {
        filter += `&Capacity=${filterCapacity.map((item) => item).join(",")}`;
      }
      if (filterStartDate && filterEndDate) {
        filter += `&StartDate=${filterStartDate}&endDate=${filterEndDate}`;
      } else if (filterStartDate) {
        filter += `&StartDate=${filterStartDate}`;
      }
      const res = await apiInstance.get(
        `${routes.getResourceMonitering}?view=${tabView}${filter}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        }
      );
      const { data } = res;
      setUserData(data);
      setCalendars(data, tabView);
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    } finally {
      setIsCalendarLoading(false);
    }
  };

  const setUserData = (record) => {
    let arr = [];
    record.forEach((item) => {
      arr.push({
        id: item.resource.id,
        name: item.resource.name,
        imageUrl: item.resource.image,
        totalHours: item?.totalCapacity,
        workLoad: item?.allocatedCapacity,
      });
    });
    setUserDetails(arr);
  };

  const getShiftDetails = (data, type, header, headerVal) => {
    const calendar = [];
    if (type.toLowerCase() === "week" || type.toLowerCase() === "month") {
      data.forEach((item) => {
        let arr = [];
        Object.values(item.availability).forEach((shift) => {
          arr.push([
            {
              totalHours: shift.totalCapacity,
              workLoad: shift.allocatedCapacity,
              timeOffs: shift.timeOffs,
              taskCount: shift.tasksCount,
              data: shift.shifts,
            },
          ]);
        });
        calendar.push(arr);
      });
    } else if (type.toLowerCase() === "day") {
      let arr = [];
      data.forEach((item) => {
        let innerArr = [];
        Object.values(item.availability).forEach((shift) => {
          if (shift.shifts.length === 0 && shift.timeOffs.length === 0) {
            innerArr.push([
              {
                id: null,
                shifts: "",
                workLoad: -1,
                totalHours: 0,
                startTime: "",
                endTime: "",
              },
            ]);
          } else {
            let dataArr = [];
            if (shift.shifts.length > 0) {
              shift.shifts.forEach((i) => {
                dataArr.push({
                  id: i.id,
                  shifts: i.name,
                  totalHours: i.totalCapacity,
                  workLoad: i.allocatedCapacity,
                  startTime: i.startTime,
                  startDate: shift.period,
                  endTime: i.endTime,
                  data: shift.shifts,
                  timeOffs: shift.timeOffs,
                });
              });
            }
            if (shift.timeOffs.length > 0) {
              shift.timeOffs.forEach((i) => {
                dataArr.push({
                  id: i.id,
                  shifts: i.name,
                  totalHours: i.duration,
                  workLoad: i.duration,
                  startTime: i.startTime,
                  endTime: i.endTime,
                  timeoff: true,
                  data: shift.shifts,
                  timeOffs: shift.timeOffs,
                });
              });
            }
            innerArr.push(dataArr);
          }
        });
        arr.push(innerArr);
      });
      calendar.push(arr);
    } else if (type.toLowerCase() === "hour") {
      data.forEach((item) => {
        let inObj = {};
        Object.values(item.availability).map((date) => {
          if (date.shifts.length > 0) {
            date.shifts.forEach((shift, index) => {
              let data = [];
              let { startTime, endTime } = shift;
              const isShiftCrossingMidnight =
                convertToMinutes(startTime) > convertToMinutes(endTime);
              startTime = tConverter(startTime);
              endTime = tConverter(endTime);
              let start = startTime;

              do {
                data.push({
                  start: start,
                  colorPercentage:
                    (Number(startTime.split(":")[1].split(" ")[0]) / 60) * 100,
                  colorType: (shift.duration / shift.capacity) * 100,
                  totalHours: isShiftCrossingMidnight
                    ? calculateCapacityTillMidnight(start, "12:00 AM")
                    : shift.totalCapacity,
                  workingHours: shift.allocatedCapacity,
                  data: [shift],
                  timeOffs: shift.timeOffs || [],
                });

                let temp = incrementTime(start);
                start = temp;
              } while (
                isShiftCrossingMidnight
                  ? start !== "12:00 AM"
                  : Number(start.split(":")[0]) !==
                  Number(endTime.split(":")[0])
              );

              inObj[
                `${date.period}${startTime.split(":")[0]}${startTime.split(" ")[1]
                }`
              ] = data;
            });
          }
        });
        calendar.push(inObj);
      });
    }

    setCalendarHeader((prev) =>
      JSON.stringify(prev) !== JSON.stringify(header) ? header : prev
    );
    setCalendarData(type.toLowerCase() === "day" ? calendar[0] : calendar);
  };

  const setCalendars = useCallback((data, type) => {
    if (!data || data.length === 0) {
      setCalendarData([]);
      setIsCalendarLoading(false);
      return;
    }

    let header = [];
    let headerVal = 0;
    const availability = Object.values(data[0].availability);

    switch (type.toLowerCase()) {
      case "week": {
        if (availability.length > 0) {
          headerVal = dayjs(
            availability[availability.length - 1].period.split(" - ")[1]
          ).year();
          availability.forEach((item) => {
            const periodParts = item.period.split(" - ");
            header.push({
              name: periodParts[0],
              date: `${periodParts[1].split("-")[2]}-${periodParts[2].split("-")[2]
                } ${new Date(periodParts[2]).toLocaleString("default", {
                  month: "short",
                })}`,
            });
          });
        }
        break;
      }

      case "month": {
        if (availability.length > 0) {
          headerVal = dayjs(availability[0].period.split(" - ")[0]).year();
          availability.forEach((item) => {
            header.push({
              name: new Date(`${item.period}-01`).toLocaleString("default", {
                month: "short",
              }),
            });
          });
        }
        break;
      }

      case "day": {
        if (availability.length > 0) {
          headerVal = dayjs(availability[0].period).year();
          const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          availability.forEach((item) => {
            const d = new Date(item.period);
            header.push({
              name: days[d.getDay()],
              date: d.getDate(),
            });
          });
        }
        break;
      }

      case "hour": {
        if (availability.length > 0) {
          headerVal = dayjs(availability[0].period).year();
          if (Array.isArray(headerDate)) {
            availability.forEach((dateItem) => {
              headerDate.forEach((hour) => {
                header.push({ date: dateItem.period, name: hour.name });
              });
            });
          }
        }
        break;
      }

      default:
        break;
    }
    getShiftDetails(data, type, header, headerVal);
  }, []);

  const modefyTimelineResponse = (timeline, baselines = null) => {
    const tasksList = [];
    let data = [];
    const links = [];
    timeline?.forEach((scope, index) => {
      let scopeDetails = {
        id: scope.id,
        text: scope.name,
        complete: scope.progress,
        start:
          scope?.startDate?.split("Z")?.[0] ||
          new Date().toISOString().split("Z")[0].split(".")[0],
        end:
          scope?.startDate?.split("Z")?.[0] ||
          new Date().toISOString().split("Z")[0].split(".")[0],
      };
      let tasks = [];
      scope.tasks.forEach((task, ind) => {
        let taskItem = {};
        taskItem.id = task.id;
        taskItem.start =
          task?.startDate?.split("Z")?.[0] ||
          new Date().toISOString().split("Z")[0].split(".")[0];
        if (task?.endDate) {
          taskItem.end = task?.endDate?.split("Z")?.[0] || "";
        } else {
          taskItem.end =
            new Date(
              new Date(task?.startDate).setDate(
                new Date(task?.startDate).getDate()
              )
            )
              .toISOString()
              .split("Z")[0]
              .split(".")[0] ||
            new Date(new Date().setDate(new Date().getDate()))
              .toISOString()
              .split("Z")[0]
              .split(".")[0];
        }
        taskItem.text = `${task.name} , ${task.status === 0
          ? "Inprogress"
          : task.status === 1
            ? "Monitoring"
            : task.status === 3
              ? "Completed"
              : "Skipping"
          } , ${task.isCritical ? "Critical" : "NonCritical"}`;
        tasks.push(taskItem);
        tasksList.push(taskItem);

        if (task.dependencies.length > 0) {
          task.dependencies.map((item) => {
            if (item.dependencyType === 0) {
              links.push({
                from: item.task.id,
                to: task.id,
                type: "FinishToStart",
              });
            } else if (item.dependencyType === 1) {
              links.push({
                from: item.task.id,
                to: task.id,
                type: "StartToStart",
              });
            }
          });
        }
        if (
          baselines &&
          baselines?.[index]?.tasks?.[ind] &&
          baselines?.[index]?.tasks?.[ind]?.startDate &&
          baselines?.[index]?.tasks?.[ind]?.endDate
        ) {
          tasks.push({
            id: baselines[index].tasks[ind].id + 1,
            start: baselines[index].tasks[ind].startDate?.split("Z")?.[0] || "",
            end: baselines[index].tasks[ind].endDate.split("Z")[0] || "",
            text: "",
          });
        }
      });
      if (tasks.length != 0) {
        scopeDetails.children = tasks;
      }

      data.push(scopeDetails);
    });
    setScopeItems(data);
    setTaskLinks(links);
    setAllTasks(tasksList);
  };

  const checkBaselineability = async () => {
    try {
      const res = await apiInstance(
        routes.bascelineability.replace(":id", project.id),
        {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        }
      );
      const { baselines, isBaselinable } = res?.data;
      setIsBaselineable(isBaselinable);
      setBaselines(baselines);
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const createBaseline = async () => {
    try {
      await apiInstance.post(
        routes.createBaseline.replace(":id", project.id),
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        }
      );
      await checkBaselineability();
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const getTasksByResourceId = async () => {
    try {
      setTaskLoader(true);
      if (useDetails?.[detail?.userIndex]) {
        let filter = "";
        if (tabView.toLowerCase() === "week") {
          if (calendarData[detail?.userIndex]?.[detail.ind]?.[0]?.data?.[0]) {
            const { startDate, endDate } =
              calendarData[detail.userIndex]?.[detail.ind]?.[0]?.data?.[0];
            filter += `&startDate=${startDate.split("T")[0]}&endDate=${endDate.split("T")[0]
              }`;
          }
        } else if (tabView.toLowerCase() === "month") {
          const requiredData =
            calendarData[detail.userIndex]?.[detail.ind]?.[0]?.data;
          if (requiredData?.[0]) {
            filter += `&startDate=${requiredData[0].startDate.split("T")[0]
              }&endDate=${requiredData[requiredData.length - 1].endDate.split("T")[0]
              }`;
          }
        } else if (tabView.toLowerCase() === "day") {
          if (calendarData?.[detail?.userIndex]?.[detail.ind]?.[0]) {
            const { startDate } =
              calendarData[detail.userIndex]?.[detail.ind]?.[0];
            filter += `&startDate=${startDate}&endDate=${startDate}`;
          }
        }
        if (tabView.toLowerCase() === "hour") {
          // hourly logic yet to be implemented
        }

        const tasks = await apiInstance.get(
          `${routes.getTasks.replace(
            ":resourceId",
            useDetails[detail.userIndex].id
          )}?view=${tabView}${filter}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage
                ?.getItem("accessToken")
                ?.replace(/"/g, "")}`,
            },
          }
        );
        if (tasks.data.tasks.length > 0) {
          setTasks(tasks.data);
        } else {
          setTasks([]);
        }
      }
      setTaskLoader(false);
    } catch (error) {
      setTaskLoader(false);
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const handleCreateScope = (payload) => {
    try {
      scopeService
        .createScopeRequest(payload)
        .then(() => {
          fetchAndSetTimelineData();
          return displatch(
            generalActions.showToast({
              title: "Scope created successfully",
              type: "success",
            })
          );
        })
        .catch((error) => {
          const {
            data: { errors },
          } = error;
          return displatch(
            generalActions.showToast({
              title: errors?.[0]?.message,
              type: "error",
            })
          );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const handleCreateTask = (payload) => {
    try {
      scopeService
        .createTaskRequest(payload)
        .then((response) => {
          fetchAndSetTimelineData();
          displatch(getProjectProgressSummary({ id: project?.id }));
          return displatch(
            generalActions.showToast({
              title: "Task created successfully",
              type: "success",
            })
          );
        })
        .catch((error) => {
          const {
            data: { errors },
          } = error;
          return displatch(
            generalActions.showToast({
              title: errors?.[0]?.message,
              type: "error",
            })
          );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const handleUpdateTask = (taskId, payload) => {
    try {
      scopeService
        .updateTaskRequest({ id: taskId, payload })
        .then((response) => {
          displatch(getProjectProgressSummary({ id: project?.id }));
          fetchAndSetTimelineData();
          // return displatch(
          //   generalActions.showToast({
          //     title: "Task updated successfully",
          //     type: "success",
          //   })
          // );
        })
        .catch((error) => {
          const {
            data: { errors },
          } = error;
          return displatch(
            generalActions.showToast({
              title: errors?.[0]?.message,
              type: "error",
            })
          );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const updateTaskDates = (taskId, dates) => {
    try {
      apiInstance
        .put(routes.taskDates.replace(":id", taskId), dates, {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        })
        .then((response) => {
          const result = response?.data?.value;
          if (result && result.isPermissible === false) {
            const conflicts = result.conflicts || [];
            const hasCapacityConflict = conflicts.some(c => c.conflictType === "ResourceCapacity");
            addConflictsToast({
              type: hasCapacityConflict ? 0 : 1,
              title: hasCapacityConflict ? "Resource Capacity Conflict" : "Task Schedule Conflict",
              body: conflicts.map(c => c.message).join("<br/> <br/> "),
            });

          }

          fetchAndSetTimelineData();
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const markTaskAsCompleted = (taskId, date) => {
    try {
      apiInstance
        .put(
          routes.markTaskCompleted.replace(":id", taskId),
          date ? { Date: date, Status: 3 } : { Status: 3 },
          {
            headers: {
              Authorization: `Bearer ${localStorage
                ?.getItem("accessToken")
                ?.replace(/"/g, "")}`,
            },
          }
        )
        .then(() => {
          displatch(getProjectProgressSummary({ id: project?.id }));
          fetchAndSetTimelineData();
          // return displatch(
          //   generalActions.showToast({
          //     title: "Task update successfull.",
          //     type: "success",
          //   })
          // );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const duplicateTask = (taskId) => {
    try {
      scopeService.duplicateTaskRequest({ id: taskId })
        .then(() => {
          displatch(getProjectProgressSummary({ id: project?.id }));
          fetchAndSetTimelineData();
          // return displatch(
          //   generalActions.showToast({
          //     title: "Task update successfull.",
          //     type: "success",
          //   })
          // );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };
  const duplicateScope = (payload) => {
    try {
      scopeService.duplicateScopeRequest(payload)
        .then(() => {
          displatch(getProjectProgressSummary({ id: project?.id }));
          fetchAndSetTimelineData();
          // return displatch(
          //   generalActions.showToast({
          //     title: "Task update successfull.",
          //     type: "success",
          //   })
          // );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };
  const addTaskDependencies = (taskId, data) => {
    try {
      apiInstance
        .put(routes.taskDependencies.replace(":id", taskId), data, {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        })
        .then(() => {
          fetchAndSetTimelineData();
          // return displatch(
          //   generalActions.showToast({
          //     title: "Task update successfull.",
          //     type: "success",
          //   })
          // );
        });
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const createTimeOff = async (data) => {
    try {
      const res = await apiInstance.post(routes.timeOff, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            ?.getItem("accessToken")
            ?.replace(/"/g, "")}`,
        },
      });
      return res;
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const deleteTimeOff = async (id) => {
    try {
      await apiInstance.delete(`${routes.timeOff}/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage
            ?.getItem("accessToken")
            ?.replace(/"/g, "")}`,
        },
      });
      return displatch(
        generalActions.showToast({
          title: "Timeoff deleted successfully.",
          type: "success",
        })
      );
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const delteShift = async (id) => {
    try {
      await apiInstance.delete(`${routes.getShiftsList}/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage
            ?.getItem("accessToken")
            ?.replace(/"/g, "")}`,
        },
      });
      return displatch(
        generalActions.showToast({
          title: "Shift deleted successfully.",
          type: "success",
        })
      );
    } catch (error) {
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    if (detail) {
      (async () => {
        await getTasksByResourceId();
      })();
    }
  }, [detail]);

  useEffect(() => {
    fetchAndSetTimelineData();
  }, [filterBaseline])

  useEffect(() => {
    if (selectedTab === "resourceMonitoring") {
      try {
        apiInstance
          .get(routes.getShiftsList, {
            headers: {
              Authorization: `Bearer ${localStorage
                ?.getItem("accessToken")
                ?.replace(/"/g, "")}`,
            },
          })
          .then((shiftsList) => {
            setShifts(shiftsList.data);
          });
      } catch (error) {
        return displatch(
          generalActions.showToast({
            title: error.message,
            type: "error",
          })
        );
      }
    }
  }, [selectedTab]);

  useEffect(() => {
    let count = 0;
    if (filterStartDate) {
      count++;
    }
    if (filterUsers.length > 0) {
      count++;
    }
    if (filterShifts.length > 0) {
      count++;
    }
    if (filterCapacity.length > 0) {
      count++;
    }
    if (filterStatus.length > 0) {
      count++;
    }
    setFilterCount(count);
  }, [filterStartDate, filterUsers, filterShifts, filterCapacity]);

  return (
    <ResourceMoniteringContext.Provider
      value={{
        peerTasks,
        setPeerTasks,
        projects,
        setProjects,
        scopes,
        setScopes,
        milestones,
        baselineScopes,
        calendarData,
        useDetails,
        calendarHeader,
        displayYearRange,
        tabView,
        todayTrigger,
        project,
        isTimelineLoading,
        isInitialTimelineLoading,
        isCalendarLoading,
        filterStartDate,
        filterEndDate,
        filterCount,
        detail,
        addShiftView,
        hourlyIdentifier,
        openPopover,
        filterUsers,
        assignedResources,
        selectedDays,
        setSelectedDays,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedValue,
        setSelectedValue,
        selectedShift,
        setSelectedShift,
        name,
        setname,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        isDefault,
        editShift,
        setEditShift,
        setIsDefault,
        setAssignedResources,
        setFilterUsers,
        setIsOpenPopover,
        setHourlyIdentifier,
        setAddShiftView,
        // fetchCalendarDetails,
        setTabView,
        setTodayTrigger,
        setProject,
        setFilterStartDate,
        setFilterEndDate,
        setDetail,
        setShifts,
        shifts,
        filterShifts,
        setFilterShifts,
        filterCapacity,
        setFilterCapacity,
        taskLoader,
        tasks,
        createTimeOff,
        deleteTimeOff,
        delteShift,
        scopeItems,
        setScopeItems,
        setFilterStatus,
        filterStatus,
        checkBaselineability,
        isBaselineable,
        setBaselines,
        baselinez,
        setFilterBaseLine,
        createBaseline,
        gantTrigger,
        setGanttTrigger,
        taskLinks,
        markTaskAsCompleted,
        duplicateTask,
        duplicateScope,
        updateTaskDates,
        addTaskDependencies,
        allTasks,
        expRes,
        setExpRes,
        expClients,
        setExpClients,
        expMettings,
        setExpMettings,
        expProjects,
        setExpProjects,
        taskId,
        setTaskId,
        fetchAndSetTimelineData,
        scopeId,
        setScopeId,
        selectedTab,
        setSelectedTab,
        handleCreateScope,
        handleCreateTask,
        handleUpdateTask,
        settings,
        // Conflicts toasts
        conflictsToasts,
        removeConflictsToast,
      }}
    >
      {children}
    </ResourceMoniteringContext.Provider>
  );
};

export { ResourceMoniteringContext, ResourceMoniteringProvider };
